import { Dialog } from '@progress/kendo-react-dialogs';
import { Loader } from '@progress/kendo-react-indicators';
import { useEffect, useState } from 'react';
import { fetchApiStream } from 'services/api';
import { MarkdownRenderer } from 'views/KnowledgeBase/MarkdownRenderer';

type Props = {
  QuoteID: number;
  CloseDialog: () => void;
};

const ActivitySummaryDialog = (props: Props) => {
  const [summary, setSummary] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadSummary = async () => {
      try {
        let receivedSummary = '';
        for await (const chunk of fetchApiStream(
          '/api/Quote/ActivitySummary',
          { QuoteID: props.QuoteID },
          'POST'
        )) {
          receivedSummary += chunk;
          setSummary(receivedSummary);
        }
        if (!receivedSummary) {
          setSummary('No summary was returned for this quote.');
        }
      } catch {
        setError(true);
      }
    };

    loadSummary();
  }, [props.QuoteID]);

  return (
    <Dialog title={`AI Recap - Quote # ${props.QuoteID}`} onClose={props.CloseDialog} className="dialog-w800">
      <div style={{ minHeight: 160 }}>
        {error && <div className="alert alert-danger">Could not generate a summary for this quote.</div>}
        {!error && !summary && <div className="text-center p-4">
          <Loader type="converging-spinner" />
          <div className="text-muted mt-2">Reading the quote history and email thread...</div>
        </div>}
        {summary && <>
          <MarkdownRenderer markdown={summary} />
          <hr />
          <small className="text-muted">
            Based on available quote activity &middot; AI generated, verify before acting
          </small>
        </>}
      </div>
    </Dialog>
  );
};

export default ActivitySummaryDialog;
